import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_ADMIN } from '@/util/roles';

export const routes = [
	{
		path: 'place-details',
		redirect: { name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.OVERVIEW },
		meta: {
			requireAuth: true,
			breadcrumb: 'Place Details',
		},
		children: [
			{
				path: 'overview',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.OVERVIEW,
				component: () => {
					return import('@/views/depot/place-details/Overview.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Place Details',
					breadcrumb: 'Overview',
				},
			},
			{
				path: 'refresh',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.REFRESH,
				component: () => {
					return import('@/views/depot/place-details/Refresh.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Refresh Place Details',
					breadcrumb: 'Refresh',
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: 'backfill',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.BACKFILL,
				component: () => {
					return import('@/views/depot/place-details/Backfill.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Backfill Place Detail Identifiers',
					breadcrumb: 'Backfill',
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: 'search',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.SEARCH,
				component: () => {
					return import('@/views/depot/place-details/Search.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Place Details',
					breadcrumb: 'Search',
				},
			},
			{
				path: 'map',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.MAP,
				component: () => {
					return import('@/views/depot/place-details/Map.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Place Details Map',
					breadcrumb: 'Map',
				},
			},
			{
				path: 'validate-csv',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.VALIDATE_CSV,
				component: () => {
					return import('@/views/depot/place-details/Validate-Csv.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Validate Place Details CSV',
					breadcrumb: 'Validate CSV',
					// Level with Import CSV: validation is the preflight for an
					// import only an admin may run, so offering it lower down
					// would present a dead end.
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: 'import-csv',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.IMPORT_CSV,
				component: () => {
					return import('@/views/depot/place-details/Import-Csv.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Import Place Details CSV',
					breadcrumb: 'Import CSV',
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: 'google-lookup',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.GOOGLE_LOOKUP,
				component: () => {
					return import('@/views/depot/place-details/Google-Lookup.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Google Place Lookup',
					breadcrumb: 'Google Lookup',
				},
			},
			{
				path: ':place_id',
				name: ROUTE_NAMES.DEPOT.PLACE_DETAILS.VIEW,
				component: () => {
					return import('@/views/depot/place-details/View-Place-Detail.vue');
				},
				meta: {
					requireAuth: true,
					title: 'Depot - Place Detail',
					breadcrumb: 'Detail',
				},
			},
		],
	},
];
